import {
    DIC
} from '@/const/dic'
import {
    validateCapitalUnderline,
    validateChinese
} from '@/util/validate'


export const walletDepositOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "帐号",
            prop: "account",
            type: 'input',
            search: true
        },
        {
            label: "用户名",
            prop: "userName",
            type: "input",
            search: true
        },
        {
            label: "真实姓名",
            prop: "realName",
            type: "input",
            search: true
        },
        {
            label: "用户区域",
            prop: "address",
            type: "input"
        },
        {
            label: "提现编号",
            prop: "withdrawNumber",
            type: "input"

        },
        {
            label: "提现金额",
            prop: "money",
            type: "input",
        },
        {
            label: "提现到",
            prop: "depositType",
            type: "select",
            search: true,
            dicData: DIC.WALLET_DEPOSIT_TAKE_TYPE
        },
        {
            label: "用户类型",
            prop: "clientType",
            type: "select",
            search: true,
            dicData: DIC.CLIENT_TYPE
        },

        {
            label: "电话",
            prop: "mobile",
            type: "input",
            search: true
        }, {
            label: "身份证号",
            prop: "idCard",
            type: "input"
        },
        {
            label: "银行卡号",
            prop: "bankNumber",
            type: "input"
        },
        {
            label: "银行名称",
            prop: "bankName",
            type: "input"
        },
        {
            label: "开户人",
            prop: "openingUserName",
            type: "input"
        }, {
            label: "开户行",
            prop: "openingBank",
            type: "input"
        }, {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            solt: true,
            dicData: DIC.WALLET_DEPOSIT_AUDIT,
            minWidth:'150'
        }, {
            label: "提现状态",
            prop: "depositStatus",
            type: "select",
            solt: true,
            search: true,
            dicData: DIC.WALLET_DEPOSIT_STATUS,
            minWidth:'150'
        },
        {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        }, {
            label: "拒绝原因",
            prop: "refusedReason",
            type: "input"
        },
        {
            label: "提现时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            search: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};